import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Database, LogIn } from "lucide-react";
import { useAdminAuth } from "../contexts/AdminAuthContext";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email.trim(), password);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(e2.message || "Erro no login");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F1829] text-white"
      style={{ fontFamily: "'Manrope', sans-serif" }}
      data-testid="admin-login-page">
      <div className="w-full max-w-md p-8 bg-[#1a2542] border border-white/10 rounded-2xl shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 grid place-items-center rounded-xl bg-[#978D78] text-[#0F1829]">
            <Database size={22} />
          </div>
          <div>
            <h1 className="text-xl font-semibold" style={{ fontFamily: "'Fraunces', serif" }}>IHTP Admin DB</h1>
            <p className="text-xs text-white/60">Manutenção de tabelas core</p>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-[11px] uppercase tracking-[0.15em] text-white/60">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="mt-1 w-full bg-[#0F1829] border border-white/15 rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#978D78]" />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.15em] text-white/60">Palavra-passe</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="mt-1 w-full bg-[#0F1829] border border-white/15 rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#978D78]" />
          </div>
          {err && <p data-testid="admin-login-error" className="text-sm text-red-400">{err}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit"
            className="w-full flex items-center justify-center gap-2 py-2.5 rounded-md bg-[#978D78] text-[#0F1829] font-semibold hover:brightness-110 disabled:opacity-50 transition">
            <LogIn size={16} /> {busy ? "A entrar..." : "Entrar"}
          </button>
        </form>

        <p className="text-[11px] text-white/40 mt-4 text-center">
          Acesso restrito. Eventos são registados em log de auditoria.
        </p>
      </div>
    </div>
  );
}
